import { ICustomerData } from "./server/model/ICustomerData";


export class CustomerData {
    CustomerId: string;
    Name: string;
    TromanEnabled: boolean;
    ValmanEnabled: boolean;
    PublikEnabled: boolean;
    IsSSOEnabled: boolean;

    constructor(json: ICustomerData) {
        //if (!json) return;

        this.CustomerId = json.CustomerId;
        this.Name = json.Name;
        this.PublikEnabled = json.PublikEnabled;
        this.TromanEnabled = json.TromanEnabled;
        this.ValmanEnabled = json.ValmanEnabled;
        this.IsSSOEnabled = json.IsSSOEnabled;
    }
}
